import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuth();

    if (!isLoading) return isAuthenticated ? children : <Navigate to="/user/login" />;
};

export default ProtectedRoute;